import { fetchAirdrop } from './fetchAirdrop.ts'
import { fetchInfo } from './fetchInfo.ts'
import { fetchNonce } from './fetchNonce.ts'
import { login } from './login.ts'
import { logout } from './logout.ts'
import { refresh } from './refresh.ts'
import { registerReferral } from './registerReferral.ts'

export const MemberApi = {
  fetchAirdrop,
  fetchInfo,
  fetchNonce,
  login,
  logout,
  refresh,
  registerReferral,
}
